module.exports = __webpack_public_path__ + "static/media/1.362474d6.jpg";